<template>
  <div>
    <v-row dense>
      <v-col>
        <v-textarea
            :disabled="readOnly"
            rows="4"
            auto-grow
            v-model="instructionsJoined"
            label="Customer Prep Instructions."
            :append-icon="willBeCondensed ? 'mdi-alert' : undefined"
        />
      </v-col>
      <v-col v-if="willBeCondensed" cols="12" md="5">
        <v-alert type="warning" dense text>
          More than 4 lines will not fit on the printed label.
          The instructions will be condensed into a single paragraph:
          <div class="condensed-preview">{{ condensedPreview }}</div>
        </v-alert>
      </v-col>
    </v-row>
    <v-expand-transition>
      <v-toolbar flat dense v-if="changed">
        <v-btn color="primary" class="mr-4" @click="save">Save</v-btn>
        <v-btn @click="revert">Cancel</v-btn>
      </v-toolbar>
    </v-expand-transition>

    <v-snackbar
        v-model="saved"
        timeout="1000"
    >
      Updated instructions
    </v-snackbar>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  name: "InstructionEditor",
  props: {
    readOnly: Boolean,
    meal: Object
  },
  mounted() {
    this.instructionsJoined = this.meal.instructions.join('\n');
  },
  data() {
    return {
      instructionsJoined: null,
      saved: false,
    }
  },
  methods: {
    ...mapActions(['updateMeal']),
    save() {
      this.meal.instructions = this.instructionsJoined.split('\n');
      this.updateMeal({mealId: this.meal.id, update: {instructions: this.meal.instructions}})
          .then(() => {
            this.saved = true;
            this.instructionsJoined = this.meal.instructions.join('\n');
          })

    },
    revert() {
      this.instructionsJoined = this.meal.instructions.join('\n');
    }
  },
  computed: {
    ...mapGetters(['getMeal']),
    changed() {
      return this.instructionsJoined !== null &&
          this.instructionsJoined !== this.meal.instructions.join('\n');
    },
    instructionLines() {
      if (!this.instructionsJoined) return [];
      return this.instructionsJoined.split('\n')
          .map(line => line.trim())
          .filter(line => line.length > 0);
    },
    willBeCondensed() {
      return this.instructionLines.length > 4;
    },
    // mirrors condenseDirections() in fed-nutrition-api (helpers/directionsHelper.ts)
    condensedPreview() {
      return this.instructionLines
          .map((line, i) => {
            if (i === this.instructionLines.length - 1) return line;
            return (line.endsWith('.') ? line : line + '.') + '  ';
          })
          .join('');
    }
  }
}
</script>

<style scoped>
.condensed-preview {
  /* preserve the double spaces between joined lines */
  white-space: pre-wrap;
  font-style: italic;
  margin-top: 8px;
}
</style>
